import styled from 'styled-components';

const VideoTheaterContainer = styled.div`
  padding: 0 28px 48px;
  margin-top: -85px;
  position: relative;

  .active {
    display: block;
  }
  .inactive {
    display: none;
  }
  .section-thankyou-hero {
    background: var(--white);
    box-shadow: 0px 30px 60px rgba(11, 26, 33, 0.15);
    padding: 38px 54px 60px;
    max-width: 1195px;
    margin: 0 auto 0;

    .section-thankyou-hero--header {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .section-thankyou-hero--title {
        font-weight: var(--font-weight-900);
        font-size: var(--font-size-25);
        line-height: var(--line-height-120);
        letter-spacing: var(--letter-spacing--0-02);
        color: var(--darkest);
      }
      .section-thankyou-hero--next-button {
        font-size: var(--font-size-16);
        line-height: var(--line-height-150);
        text-align: center;
        letter-spacing: var(--letter-spacing--0-01);
        padding: 12px 15px;
      }
    }

    .section-thankyou-hero--main-content {
      align-items: center;
      background: var(--skyline-1);
      margin-top: 37px;

      .section-thankyou-hero--main-text {
        background: var(--skyline-1);
        padding: 20px 34px;

        .section-thankyou-hero--main-title {
          font-weight: var(--font-weight-900);
          font-size: var(--font-size-28);
          line-height: var(--line-height-110);
          letter-spacing: var(--letter-spacing--0-03);
          color: var(--darkest);
        }
        .section-thankyou-hero--main-description {
          font-weight: var(--font-weight-500);
          font-size: var(--font-size-16);
          line-height: var(--line-height-150);
          margin: 30px 0 0;
          color: var(--dark);
        }
      }
    }

    .section-thankyou-hero--next-button-mobile {
      display: none;
    }


    .wistia-video--wrapper {
      width: 100%;
      height: 100%;

      @media (max-width: 575px) {
        height: 220px;
      }
    }

    .section-thankyou-hero--video-list {
      display: flex;
      margin-top: 41px;

      .section-thankyou-hero--video-item {
        background: var(--white);
        box-shadow: 0px 3px 10px rgba(11, 26, 33, 0.08);
        cursor: pointer;
        transition-timing-function: ease-out;
        transition: 0.25s;
        height: 100%;

        .section-thankyou-hero--video-item-video-cover {
          display: flex;
          position: relative;
          height: fit-content;
          object-fit: cover;
          width: 100%;

          .wistia-video--wrapper {
            height: auto
          }

          img {
            width: 100%;
          }

          video {
            width: 100%;
            height: auto;
          }

          .section-thankyou-hero--video-item-video-overlay {
            width: 100%;
            height: 100%;
            position: absolute;
            background: var(--titan-blue-3);
            opacity: 0.7;
            display: none;
          }

          .section-thankyou-hero--item-now-playing {
            font-weight: var(--font-weight-900);
            font-size: var(--font-size-20);
            line-height: var(--line-height-110);
            letter-spacing: var(--letter-spacing--0-01);
            color: var(--white);
            position: absolute;
            margin: 19px 21px;
            display: none;
          }
        }
        .section-thankyou-hero--video-item-text-cover {
          padding: 23px 21px;

          .section-thankyou-hero--video-item-title {
            font-weight: var(--font-weight-500);
            font-size: var(--font-size-16);
            line-height: var(--line-height-150);
            color: var(--darkest);
          }
        }

        &:last-child {
          margin-right: 0;
        }

        &:hover {
          box-shadow: 0px 15px 40px rgba(11, 26, 33, 0.1);
        }

        &.current-playing {
          .section-thankyou-hero--video-item-video-overlay,
          .section-thankyou-hero--item-now-playing {
            display: block;
          }
        }
      }
    }
  }

  @media (max-width: 1190px) {
    .section-thankyou-hero--container {
      .section-thankyou-hero {
        .section-thankyou-hero--main-content {
          .section-thankyou-hero--main-text {
            min-width: 300px;
            max-width: 300px;

            .section-thankyou-hero--main-title {
              font-size: var(--font-size-22);
              line-height: var(--line-height-110);
              letter-spacing: var(--letter-spacing--0-02);
            }
            .section-thankyou-hero--main-description {
              font-weight: var(--font-weight-500);
              font-size: var(--font-size-16);
              line-height: var(--line-height-150);
            }
          }
        }
      }
    }
  }

  @media (max-width: 901px) {
    .section-thankyou-hero {
      margin-top: 40px;
      padding: 32px;

      .section-thankyou-hero--header {
        .section-thankyou-hero--title {
          font-size: var(--font-size-20);
          letter-spacing: var(--letter-spacing--0-01);
        }
        .section-thankyou-hero--next-button {
          font-size: var(--font-size-13);
          line-height: var(--line-height-110);
          padding: 16px;
        }
      }

      .section-thankyou-hero--main-content {
        margin-top: 30px;
        flex-direction: column;

        .section-thankyou-hero--main-text {
          min-width: 0px;
          max-width: 100%;
          padding: 24px 24px 48px;
        }
      }

      .section-thankyou-hero--video-list {
        margin-top: 32px;

        .section-thankyou-hero--video-item {
          margin-right: 31px;

          .section-thankyou-hero--video-item-video-cover {
            .section-thankyou-hero--item-now-playing {
              font-size: var(--font-size-18);
              line-height: var(--line-height-120);
              margin: 12px;
            }
          }
          .section-thankyou-hero--video-item-text-cover {
            padding: 16px;
          }
        }
      }
    }
  }

  @media (max-width: 575px) {
    margin-top: -285px;
    
    .section-thankyou-hero {
      margin-top: 40px;
      padding: 32px;

      .section-thankyou-hero--header {
        justify-content: center;

        .section-thankyou-hero--next-button {
          display: none;
        }
      }

      .section-thankyou-hero--main-content {
        .section-thankyou-hero--main-text {
        }
      }

      .section-thankyou-hero--next-button-mobile {
        display: block;
        margin-top: 24px;
        font-size: var(--font-size-13);
        line-height: var(--line-height-110);
        text-align: center;
        color: var(--white);
        padding: 16px;
        margin: 24px auto 0;
      }

      .section-thankyou-hero--video-list {
        margin-top: 40px;
        flex-direction: column;

        .section-thankyou-hero--video-item {
          margin: 0 0 24px;

          .section-thankyou-hero--video-item-video-cover {
            .section-thankyou-hero--item-now-playing {
              font-size: var(--font-size-20);
              line-height: var(--line-height-110);
              margin: 16px 18px;

            .section-thankyou-hero--video-item-text-cover {
              padding: 16px;
            }
          }
          .section-thankyou-hero--video-item-text-cover {
            padding: 16px;
          }
        }
      }
    }
  }
`;

export { VideoTheaterContainer };
